export enum Role {
  VIEWER = 0,
  OPERATOR = 1,
  ADMIN = 2,
  SUPER_USER = 3,
}

export const roleMap = {
  0: 'Viewer',
  1: 'Operator',
  2: 'Admin',
  3: 'Super User',
};

export const isViewer = (currentRole: Role) => {
  return currentRole === Role.VIEWER;
};

export const isOperatorOrHigher = (currentRole: Role) => {
  return currentRole > Role.VIEWER;
};

export const isAdmin = (currentRole: Role) => {
  return currentRole > Role.OPERATOR;
};

export const isSuperUser = (currentRole: Role) => {
  return currentRole === Role.SUPER_USER;
};
